import React, { useState } from "react";
import "./Commission_Details.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import DateFilterOffcanvas from "../Common/Common_Component/Filter_Drop/DateFilterOffcanvas/DateFilterOffcanvas";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown } from "@fortawesome/free-solid-svg-icons";
import Commission_Details_card from "./Commission_Details_card/Commission_Details_card";
import No_data from "../Common/No_data/No_data";

function Commission_Details() {
  const [showDate, setShowDate] = useState(false);
  const [selectedDate, setSelectedDate] = useState("Date");

  return (
    <>
      <section className="Commission_Details">
        <Common_white_header headingText={"Commission Details"} />
        <div className="container">
          <section className="Filter_Drop">
            <div className="filter-row">
              <div className="filter-item" onClick={() => setShowDate(true)}>
                <span>{selectedDate}</span>
                <FontAwesomeIcon icon={faSortDown} />
              </div>
            </div>
          </section>

          <Commission_Details_card/>
          <Commission_Details_card/>
          <Commission_Details_card/>
          <Commission_Details_card/>
          <Commission_Details_card/>

           <No_data/>
        </div>
      </section>
      <DateFilterOffcanvas
        show={showDate}
        handleClose={() => setShowDate(false)}
        onApplyDate={setSelectedDate}
      />
    </>
  );
}

export default Commission_Details;
